/**
 * 核心 
 * @module Core
 */

;(function (ui,$) {
   
    /**
     * ready 页面准备完毕
     * @namespace  bui
     * @class  ready
     * @constructor 
     * @param  {[function]} callback [回调]
     * @example
     *
         bui.ready(function(){
             //控件的初始化及业务逻辑,都应该这里执行
         })
     *
     */
    ui.ready = function (callback) {
        //默认是调试模式, false为原生模式
        if( this.debug == false ){
            if( typeof cordova === 'undefined' || typeof app === 'undefined'){
              console.log("请检查页面有没有引入 Cordova.js 及 bingotouch.js");
            }else if(ui.platform().isMac() || ui.platform().isWindow() ){
              console.log("调用手机原生功能,需要在debugtool中打开");
            }else {
              //使用phonegap
              document.addEventListener("deviceready", function() {

                  callback && callback();
              }, false);
            }
        }else{

            if( this.debug && ui.platform().isWeiXin() ){
              
              //testing 配合 bt4.0
              if( app && app.init ){
                // 需要建权,会比较慢加载
                window.onload = function () {
                  // weixinConfig 在 js/app/_config.js 里面
                  if( !weixinConfig || weixinConfig.appId == "" || weixinConfig.appSecret == ""){
                    console.log("微信开发请检查 js/app/_config.js weixinConfig的配置");
                    return false;
                  };

                  app.init(weixinConfig,function () {
                    callback && callback();
                  });
                  
                }
              }else{
                
                $(document).ready(function () {
                  callback && callback();
                });
              }
              
            }else{
              $(document).ready(function () {
                callback && callback();
              });
            }
        }
   }; 

  return ui;

})( bui || {}, libs );
